import { LoadingOutlined } from '@ant-design/icons'
import { Input, message, Modal, Select, Spin } from 'antd'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import DynamicTable from '../../../Components/TableComponents/DynamicTable'
import { getTicketCategory, updateTicketCategory, updateWorkOrderById } from '../../../Services/LocomotiveServices'

const WODescriptionModal = ({ open, close, modalData, setReloadState: reload }) => {

    const [selectedOption, setSelectedOption] = useState(undefined)


    useEffect(() => {
        if (open) {
            setSelectedOption(modalData?.values?.Description || undefined)
        }
    }, [open])

    const onClickSave = async () => {
        let res = await updateWorkOrderById(modalData?.values?.id, { Description: selectedOption })
        if (res?.httpStatus === 200) {
            message.success('Description Updated Successfully!')
            close()
            reload(prev => prev = !prev)
        }
    }

    return (
        <Modal
            open={open}
            onCancel={() => {
                close()
            }}
            footer={null}
            title="Update WO Description"
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <span style={{ fontSize: "13px" }}>WO Description</span>
                        <Input.TextArea
                            rows={4}
                            placeholder="Enter Description"
                            value={selectedOption}
                            onChange={e => setSelectedOption(e.target.value)}
                            maxLength='1000'
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        style={{ background: "#2863AD", color: "white", padding: "10px 20px", border: "none", borderRadius: "10px", cursor: "pointer", opacity: selectedOption ? "1" : "0.4" }}
                        onClick={onClickSave}
                        disabled={selectedOption ? false : true}
                    >
                        Update
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default WODescriptionModal